import * as React from 'react';

export function Ascending(): React.ReactElement {
  return (
    <svg
      className="fill-grey-800"
      aria-hidden={true}
      width="12"
      height="12"
      viewBox="0 0 12 12"
    >
      <path
        fillRule="nonzero"
        d="M5.293 3.293l-4 4C.663 7.923 1.109 9 2 9h8c.89 0 1.337-1.077.707-1.707l-4-4a1 1 0 00-1.414 0z"
      />
    </svg>
  );
}

export function Descending(): React.ReactElement {
  return (
    <svg
      className="fill-grey-800"
      aria-hidden={true}
      width="12"
      height="12"
      viewBox="0 0 12 12"
    >
      <path
        fillRule="nonzero"
        d="M6.707 8.707l4-4C11.337 4.077 10.891 3 10 3H2c-.89 0-1.337 1.077-.707 1.707l4 4a1 1 0 001.414 0z"
      />
    </svg>
  );
}